import axios from '@/libs/api.request'

export const matchUsersWithNameOrEmail = (keyword) => {
  return axios.request({
    url: 'users/match/' + keyword,
    method: 'get'
  })
}

export const getAllUsers = () => {
  return axios.request({
    url: 'users/list',
    method: 'get'
  })
}
